<!-- Alert.vue -->
<template>
  <Transition name="fade">
    <div
      v-if="isVisible"
      :class="[
        'alert',
        props.alertClass,
        'flex justify-between items-center py-2 px-4 my-2 rounded-md',
      ]"
      role="alert"
    >
      <div class="flex items-center">
        <DefaultIcon
          v-if="props.icon"
          :name="props.icon"
          size="h-5 w-5"
          class="mr-2"
        />
        <span>{{ props.text }}</span>
      </div>
      <button
        v-if="props.dismissible"
        @click="hideAlert"
        class="btn btn-ghost btn-sm btn-circle hover:bg-base-300"
        aria-label="Close alert"
      >
        <DefaultIcon name="xMark" />
      </button>
    </div>
  </Transition>
</template>

<script setup>
import { ref, defineProps, defineEmits } from "vue";
import DefaultIcon from "@/components/icons/DefaultIcon.vue";

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  alertClass: {
    type: String,
    default: "",
  },
  icon: {
    type: String,
    default: "warning",
  },
  dismissible: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["dismiss"]);
const isVisible = ref(true);

const hideAlert = () => {
  isVisible.value = false;
  emit("dismiss");
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
